import { isNullOrEmpty } from '../utils/util';

export default class Dao {
    constructor(connection, store) {
        this.connection = connection;
        this.store = store;
    }

    cursor(indexName, singleKeyRange) {
        return !isNullOrEmpty(indexName) ? this.connection
            .transaction([this.store], 'readwrite')
            .objectStore(this.store)
            .index(indexName)
            .openCursor(singleKeyRange) : this.connection
                .transaction([this.store], 'readwrite')
                .objectStore(this.store)
                .openCursor();
    }

    find(id, indexName) {
        return new Promise((resolve, reject) => {
            const request = !isNullOrEmpty(indexName) ? this.connection
                .transaction([this.store], 'readwrite')
                .objectStore(this.store)
                .index(indexName)
                .get(id) : this.connection
                    .transaction([this.store], 'readwrite')
                    .objectStore(this.store)
                    .get(id);

            request.onsuccess = () => {
                resolve(request.result);
            };
            request.onerror = (e) => {
                // eslint-disable-next-line no-console
                console.log('Error', e.target.error);
                reject(e.target.error);
            };
        });
    }

    getAll(indexName, indexValue) {
        return new Promise((resolve, reject) => {
            const items = [];
            const cursor = this.cursor(indexName, indexValue);
            cursor.onsuccess = (e) => {
                const atual = e.target.result;
                if (atual) {
                    if ((!isNullOrEmpty(indexName) && atual.value[indexName] === indexValue) || isNullOrEmpty(indexName)) {
                        items.push(atual.value);
                    }
                    atual.continue();
                } else {
                    resolve(items);
                }
            };
            cursor.onerror = (e) => {
                // eslint-disable-next-line no-console
                console.log('Error', e.target.error);
                reject(e.target.error);
            };
        });
    }

    search(filter, indexName, indexValue) {
        return new Promise((resolve, reject) => {
            const items = [];
            const cursor = this.cursor(indexName, indexValue);
            cursor.onsuccess = (e) => {
                const atual = e.target.result;
                if (atual) {
                    if ([atual.value].filter(filter).length > 0) {
                        items.push(atual.value);
                    }
                    atual.continue();
                } else {
                    resolve(items);
                }
            };
            cursor.onerror = (e) => {
                // eslint-disable-next-line no-console
                console.log('Error', e.target.error);
                reject(e.target.error);
            };
        });
    }

    add(item) {
        if (!item.id) {
            item.dataStatus = 'I';
            item.id = (+new Date());
            item.lastChangeDate = new Date();
        }
        return new Promise((resolve, reject) => {
            const transaction = this.connection.transaction([this.store], 'readwrite');
            const objectStore = transaction.objectStore(this.store);
            const exists = !!objectStore.getKey(item.id);
            let request;

            if (exists) {
                request = objectStore.put(item);
            } else {
                request = objectStore.add(item);
            }

            request.onsuccess = () => {
                resolve(item);
            };
            request.onerror = (e) => {
                // eslint-disable-next-line no-console
                console.log('Não foi possível addr um item', e.target.error);
                reject(e.target.error);
            };
        });
    }

    update(val) {
        if (!val.dataStatus) {
            val.dataStatus = 'U';
        }
        // eslint-disable-next-line no-console
        console.log(this.connection);
        // eslint-disable-next-line no-console
        console.log(this.store);
        val.lastChangeDate = new Date();
        return new Promise((resolve, reject) => {
            const request = this.connection
                .transaction([this.store], 'readwrite')
                .objectStore(this.store)
                .put(val);
            request.onsuccess = () => {
                resolve();
            };
            request.onerror = (e) => {
                reject(e.target.error);
            };
        });
    }

    addRange(items) {
        this.removeAll().then(() => {
            items.map((item) => this.add(item));
        });
    }

    remove(id) {
        return new Promise((resolve, reject) => {
            const request = this.connection
                .transaction([this.store], 'readwrite')
                .objectStore(this.store)
                .get(id);

            request.onsuccess = () => {
                if (request.result) {
                    request.result.dataStatus = 'D';
                    this.update(request.result);
                    resolve(request.result);
                }
            };
            request.onerror = (e) => {
                // eslint-disable-next-line no-console
                console.log('Não foi possível apagar os items', e.target.error);
                reject(e.target.error);
            };
        });
    }

    removeAll() {
        return new Promise((resolve, reject) => {
            const request = this.connection
                .transaction([this.store], 'readwrite')
                .objectStore(this.store)
                .clear();
            request.onsuccess = () => {
                resolve('Apagadas!');
            };
            request.onerror = (e) => {
                // eslint-disable-next-line no-console
                console.log('Não foi possível apagar os items', e.target.error);
                reject(e.target.error);
            };
        });
    }
}
